
import api from '../../../api/apiService';
import { ENDPOINTS } from '../../../api/endpoints';

import type {
  EmployeeRolePermissionsRequest,
  EmployeeRolePermissionsResponse,
} from '../types/rolePermissions.types';

export interface EmployeeRoleResponse {
  employeeCode: string;
  roleId: number;
  roleName: string;
  isActive: boolean;
}

// Get permissions for the selected role.
export const getRolePermissions = async (
  employeeCode: string,
  roleId: number,
): Promise<EmployeeRolePermissionsResponse> => {
  const request: EmployeeRolePermissionsRequest = {
    employeeCode,
    roleId,
  };

  const response = await api.post<EmployeeRolePermissionsResponse>(
    ENDPOINTS.EMPLOYEE_ROLE_PERMISSIONS,
    request,
  );

  return response.data;
};

// Get all assigned roles for the employee.
export const getEmployeeRolesByCode = async (
  employeeCode: string,
): Promise<EmployeeRoleResponse[]> => {
  const response = await api.get<EmployeeRoleResponse[]>(
    ENDPOINTS.ROLE_PERMISSIONS_BY_EMPLOYEE_CODE,
    {
      params: { EmployeeCode: employeeCode },
    },
  );

  return response.data;
};
